import { render, staticRenderFns } from "./OrderPrefix.vue?vue&type=template&id=8e84cd56"
import script from "./OrderPrefix.vue?vue&type=script&lang=js"
export * from "./OrderPrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports